import { useEffect, useState } from "react";
import operatorApiService from "../../../../services/operator-api.service";
import BaseEditModal from "../modal/BaseEditModal";
import editIcon from "../../../../assets/imgs/master/edit_icon_wh.svg";

interface BaseInfoProps {
  baseId: number | null;
}

interface BaseInfo {
  base_id: number;
  base_name: string;
  zao_cloud_url: string;
  credential: string;
  map_latitude: number;
  map_longitude: number;
  map_zoom: number;
  monitor_error_cd: string;
}

const BaseInfo = ({ baseId }: BaseInfoProps) => {
  const [base, setBase] = useState<BaseInfo | null>(null);
  const [isEditBaseOpen, setIsEditBaseOpen] = useState(false);

  const fetchBase = async () => {
    const baseData = await operatorApiService.doGetBase({ baseId });
    setBase(baseData);
  };

  useEffect(() => {
    if (!baseId) return;
    fetchBase();
  }, [baseId]);

  const handleEditBase = () => {
    if (base) {
      setIsEditBaseOpen(true);
    }
  };

  return (
    <div className="section">
      <div className="sectionTitle">拠点</div>
      <div className="sectionBody">
        <div className="baseArea">
          <div>拠点 : </div>
          <div>{base?.base_name}</div>
          <button className="updateButton" onClick={handleEditBase}>
            <img src={editIcon} alt="" className="icon" />
            編集
          </button>
        </div>
      </div>

      <BaseEditModal
        isOpen={isEditBaseOpen}
        base={base}
        onClose={() => setIsEditBaseOpen(false)}
        onSuccess={fetchBase}
        onUpdateBase={(updated) => setBase(updated)}
      />
    </div>
  );
};

export default BaseInfo;
